import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { trackPage } from '../Pages/LeadVettingPage/utils';

// This is a custom hook which updates the pageview analytics everytime the url changes

const usePageviewAnalytics = () => {
  const history = useHistory();

  useEffect(() => {
    if (!history) {
      return () => {};
    }
    const unlisten = history.listen((location) => {
      trackPage(`${location.pathname}`);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return null;
};

export default usePageviewAnalytics;
